import { Globe, Users, Phone, UserPlus, Sparkles, Tag } from "lucide-react";

/**
 * Color + icon mapping for the `lead_source` field on contacts/projects.
 * Designed to be tiny and inline next to a name. Shows nothing when source
 * is empty/missing rather than a noisy "Unknown" badge.
 */
const META = {
  website:           { label: "Website",  Icon: Globe,    color: "#0EA5E9", bg: "bg-sky-50",     border: "border-sky-200" },
  referral:          { label: "Referral", Icon: Users,    color: "#10B981", bg: "bg-emerald-50", border: "border-emerald-200" },
  referral_partner:  { label: "Partner",  Icon: Users,    color: "#0F766E", bg: "bg-teal-50",    border: "border-teal-200" },
  manual:            { label: "Manual",   Icon: UserPlus, color: "#64748B", bg: "bg-slate-50",   border: "border-slate-200" },
  phone:             { label: "Phone",    Icon: Phone,    color: "#F59E0B", bg: "bg-amber-50",   border: "border-amber-200" },
  phone_call:        { label: "Phone",    Icon: Phone,    color: "#F59E0B", bg: "bg-amber-50",   border: "border-amber-200" },
  instant_estimator: { label: "Estimator",Icon: Sparkles, color: "#A855F7", bg: "bg-purple-50",  border: "border-purple-200" },
};

export default function SourceBadge({ source, size = "sm" }) {
  if (!source) return null;
  const m = META[source.toLowerCase()] || {
    label: source.replace(/_/g, " "),
    Icon: Tag,
    color: "#475569",
    bg: "bg-slate-50",
    border: "border-slate-200",
  };
  const Icon = m.Icon;
  const dims = size === "xs"
    ? "text-[10px] px-1.5 py-0.5 gap-1"
    : "text-xs px-2 py-0.5 gap-1.5";
  return (
    <span
      className={`inline-flex items-center font-medium rounded-md border ${m.bg} ${m.border} ${dims} capitalize`}
      style={{ color: m.color }}
      data-testid={`source-badge-${source}`}
      title={`Lead source: ${m.label}`}
    >
      <Icon className={size === "xs" ? "w-2.5 h-2.5" : "w-3 h-3"} />
      {m.label}
    </span>
  );
}
